import React, {useEffect, useState, useCallback} from 'react'
import {serviceGetAdminDetails, serviceGetAssociateClients, serviceGetAssociatePrograms} from "../../../services/AdminUsers.service";
import { useParams } from "react-router-dom";
import history from "../../../libs/history.utils";
import RouteName from "../../../routes/Route.name";

const useAdminUsersDetail = () => {
  const [adminDetails, setAdminDetails] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    serviceGetAdminDetails({ id: id ? id : "" }).then((res) => {
      if (!res?.error) {
        setAdminDetails(res?.data);
      }
    });
  }, [id]);

 

  function getInitials(name) {
    if (!name || name.trim() === "") return "";   
    const nameParts = name.split(' ');     
    if (nameParts[0] && nameParts[1]) {       
      const initials = nameParts[0][0]?.toUpperCase() + nameParts[1][0]?.toUpperCase();
      return initials;
    }
    return nameParts[0][0]?.toUpperCase();
  }

  const handleEdit = useCallback(() => {
    if (id) {
      history.push(`${RouteName.ADMIN_UPDATE}${id}`);
    } else {
      console.error('ID is undefined');
    }
  }, [id, history]);

  return {
    adminDetails,
    getInitials,
    handleEdit
  };

};
export default useAdminUsersDetail;